"use client";

import { useEffect } from "react";

import { installClientLogReporter } from "@/lib/logging/client-logger";

/**
 * Mounts the browser log reporter once for the whole app: starts periodic
 * flushing and global error/rejection capture, forwarding to /api/client-logs.
 * Renders nothing.
 */
export function ClientLogReporter() {
  useEffect(() => installClientLogReporter(), []);
  return null;
}
